import { readItem } from '@directus/sdk';
import { redirect } from 'react-router';

import { getPromoterId } from '#data/user/getPromoterId.ts';
import { readCurrentUser } from '#data/user/useUserQuery.ts';

import { directusClient } from '../services/directusClient/directusClient.ts';

export const dashboardLoader = async () => {
  try {
    const me = await readCurrentUser();
    const promoterId = getPromoterId(me);
    if (!promoterId) {
      return redirect('/log-in-as');
    }
    const promoter = await directusClient.request(readItem('promoters', promoterId));

    if (!me.has_agreed_to_community_notes) {
      return redirect('/community-notes');
    }

    if (!promoter.onboarding_done) {
      return redirect('/onboarding');
    }

    return null;
  } catch {
    return redirect('/auth/login');
  }
};
